import { RMAXLogger } from '../../../../services/LoggerService/RMAXLogger';

const logPickupEvent = (pickupData, eventName) => {
  let pickupIds = pickupData.pickupIds;
  if (pickupData.success && pickupData.pickupIds && pickupData.pickupIds.length > 0) {
    // Use pickupIds array for multiple pickups, fallback to single pickupId
    pickupIds = pickupData.pickupIds;
  } else if (pickupData.success && pickupData.pickupId) {
    pickupIds = [pickupData.pickupId];
  }
  RMAXLogger.info(`Pickup SignalR : ${eventName}`, {
    eventType: eventName,
    pickupIds,
    success: pickupData.success,
    driverId: pickupData.driverId,
    message: pickupData.message || ''
  });
};

const getPickupProcessingCount = (processedPickupsRef, pendingPickupEventRef) => {
  if (!pendingPickupEventRef.current) {
    return '';
  }

  const processedPickupCount = processedPickupsRef.current.length;
  const pendingPickupCount = pendingPickupEventRef.current.pickupIds.length;
  
  if (pendingPickupCount > 0) {
    return `${processedPickupCount}/${processedPickupCount + pendingPickupCount}`;
  }
  return `${processedPickupCount}/${processedPickupCount}`;
};

// Update pickup ID to uppercase in success/failed event data.
const normalizePickupIds = (pickupData) => {
  if (pickupData.pickupIds) {
    pickupData.pickupIds = pickupData.pickupIds.map(id => id.toUpperCase());
  }
};

export { logPickupEvent, getPickupProcessingCount, normalizePickupIds };
